import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { 
    trackPageView, 
    trackHomePageView, 
    trackBillingPageView, 
    trackAnalyticsPageView, 
    trackTemplatePageView, 
    trackSettingsPageView, 
    trackOnboardingPageView, 
    trackBuilderPageView, 
    trackHelpCenterPageView, 
    trackLoginPageView,
    trackExclusivePlansPageView
} from '@/utils/analytics'

export const usePageTracking = (pageName: string, additionalProperties?: Record<string, any>) => {
    const location = useLocation()

    useEffect(() => {
        // Use specific tracking functions for known pages
        switch (pageName.toLowerCase()) {
            case 'login':
                trackLoginPageView()
                break
            case 'home':
            case 'surveys':
            case 'dashboard':
                trackHomePageView()
                break
            case 'billing':
            case 'billing plans':
                trackBillingPageView()
                break
            case 'exclusive plans':
                trackExclusivePlansPageView()
                break
            case 'analytics':
                trackAnalyticsPageView(additionalProperties?.survey_id)
                break
            case 'templates':
            case 'survey templates':
                trackTemplatePageView()
                break
            case 'settings':
                trackSettingsPageView()
                break
            case 'onboarding':
                trackOnboardingPageView()
                break
            case 'builder':
            case 'survey builder':
                trackBuilderPageView(additionalProperties?.survey_id)
                break
            case 'help':
            case 'help center':
                trackHelpCenterPageView()
                break
            default:
                trackPageView(pageName, additionalProperties)
        }
    }, [location.pathname, pageName, additionalProperties])
} 